export const lang = {
    menu:{
        Home:"首页",
        Class:'分类',
        ShoppingCart:'购物车',
        My:'我的'
    },
    my:{
        MyOrder:'我的订单',
        AllOrders:'全部订单',
        PrePayment:'代付款',
        Delivery:'代发货',
        Receipt:'待收货',
        Estimate:'待评价',
        CouponCenter:'领券中心',
        MyAddress:'我的地址',
        MyDiscountCoupon:'我的优惠券',
        MyBargain:'我的砍价',
        MyScores:'我的积分',
        HelpCenter:'帮助中心',
        DistributionCenter:'分销中心',
        DropOut:'退出',
        TermsofUse:'使用条款',
        MyCreditCard:'我的信用卡'
    },
    clause:{
        ReturningProvisions:'退货条款',
        PaymentMethod:'支付方式',
        PrivacyPolicy:'隐私条款',
        MailingInformation:'邮寄信息',
        TermsOfUse:'使用条款',
    },
    // 其他
    other:{
        Settlement:"结算",
    },
    //订单结算
    OrderSettlement:{
        CourierDelivery:'快递配送',
        PickItUpAtHome:'上门自提',
        PriceOfCommodities:'商品价格',
        Coupon:'优惠券',
        DeliveryFee:'配送费',
        PromoCode:'优惠码',
        ACombined:'合计',
        ModeOfPayment:'支付方式',
        ActualPayment:'实付款',
        ConfirmPayment:'确认付款',
        CreditCardPayment:'信用卡支付'
    },
    //商品详情
    goodsShow:{
        ImmediatePurchase:'立即购买',
        AddToCart:'加入购物车',
        HomePage:'首页',
        TheShoppingCart:'购物车',
    },
}
